module.exports = __webpack_public_path__ + "media/character/character01-1b323ac4.png";